<section class="about-hero">
  <div class="container">
    <h1>About League City Yacht Sales</h1>
    <p class="subtitle">Your Full-Service Expert Yacht Brokerage</p>
  </div>
</section>

<section class="intro-section">
  <div class="container">
    <div class="intro-grid">
      <div class="intro-text">
        <h2>Building the finest yachting experience one deal at a time.</h2>
      </div>
      <div class="intro-desc">
        <p>
          Every deal is unique. The team at League City Yacht Sales goes above and beyond to make sure we have a deep
          understanding of your goals from the first inquiry to the final handover.
        </p>
      </div>
    </div>
  </div>
</section>

<section class="brokerage-team">
  <div class="container">
    <app-section-title title="Our Expert Brokerage Team" theme="dark" subtitle=""></app-section-title>

    <div class="broker-details-row">
      <div class="broker-detail-card">
        <div class="broker-profile-container">
          <div class="broker-image-wrapper">
            <img src="assets/images/team/stephen-seger.jpg" alt="Stephen Seger" class="broker-profile-img" />
          </div>
          <div class="broker-content-wrapper">
            <h3 class="broker-name-large">
              Stephen Seger
              <span class="broker-title">Owner & Senior Broker</span>
            </h3>
            <div class="broker-bio">
              <p>Stephen Seger has been a full-time yacht broker since 2019 having helped clients pursue thousands of
                yachts in the United States, Canada, Mexico, the Caribbean, and Europe. Stephen is a Texas-native with a
                first love of the water. He grew up fishing inshore and offshore fishing tournaments in Texas including
                Poco Bueno, Legends, TIFT, TWAT, and Babes on the Bay just to name a few.</p>
              <p>Stephen has been a brokerage owner since 2021 that specializes in both power and sail ranging from 20’
                – 100'+. He is an industry expert at understanding the needs of buyer and seller needs during a deal and
                has been fortunate to be the highest volume broker in Texas in 2024 and 2025.</p>
              <p>Raised in Houston, he is well-connected in the Houston and Galveston area and has a driving and
                entrepreneurial passion to help clients and brokers alike in the marine industry.</p>
              <p>Stephen can be reached at (713) 828 – 3642 or stephen&#64;leaguecityyachtsales.com.</p>
            </div>

            <!-- <div class="partners-grid" style="margin-top: 40px; border-top: 1px solid #ddd; padding-top: 30px;">
              <div class="additional-team">
                <div class="broker-info-sub">
                  <h3 class="broker-name-sub">CMIT Solutions</h3>
                  <p class="broker-title-sub">Head of technical support</p>
                </div>
              </div>

              <div class="additional-team">
                <div class="broker-info-sub">
                  <h3 class="broker-name-sub">TLC Software</h3>
                  <p class="broker-title-sub">Head of technical development</p>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="broker-detail-card">
        <div class="broker-profile-container">
          <div class="broker-image-wrapper">
            <img src="assets/images/team/andi-gilmore.jpeg" alt="Andi Gilmore" class="broker-profile-img" />
          </div>
          <div class="broker-content-wrapper">
            <h3 class="broker-name-large">
              Andi Gilmore
              <span class="broker-title">Closing Coordinator and Broker-In-Training</span>
            </h3>
            <div class="broker-bio">
              <p>Andi has a background in luxury sales, custom jewelry, and client relationship management where she
                brings strong attention to detail, clear communication, and a personalized approach to every
                transaction.</p>
              <p>Raised in Chambers County, Andi grew up near the water and has a strong connection to communities
                throughout the Houston, Galveston, and Southeast Texas. Her local knowledge and passion for helping
                people make her a natural fit for the marine industry.</p>
              <p>As Closing Coordinator, Andi works closely with buyers, sellers, brokers, lenders, and documentation
                professionals to help keep each transaction organized and moving smoothly from contract to closing. She
                is actively training as a yacht broker expanding her knowledge of vessel listings, market values,
                documentation, and the buying and selling process.</p>
              <p>Andi can be reached at (832) 628 - 0919 or andi@leaguecityyachtsales.com. </p>
            </div>


          </div>
        </div>
      </div>
      <div class="broker-detail-card">
        <div class="broker-profile-container">
          <div class="broker-image-wrapper">
            <img src="assets/images/team/roy-bowman.jpeg" alt="Roy Bowman" class="broker-profile-img" />
          </div>
          <div class="broker-content-wrapper">
            <h3 class="broker-name-large">
              Roy Bowman
              <span class="broker-title">Yacht Broker</span>
            </h3>
            <div class="broker-bio">
              <p>Roy Bowman grew up in Houston and spent his summers on Galveston Bay at the Houston Yacht Club. Roy was
                captain of the sailing team at the University of Texas in Austin and has been competitively sailing most
                of his life. After graduating from college he became a member of Texas Corinthian Yacht Club in Kemah
                where his family and he enjoy their time.</p>
              <p>Roy is well connected to many mariners up and down the Texas Gulf Coast and also has a strong passion
                for fishing. He is familiar with large power boats and enjoys offshore fishing. He recently joined
                League City Yacht Sales as a broker, bringing with him his knowledge of power and sailing craft. He is
                very personable and has strong attention to detail.</p>
              <p>Roy can be reached at 713-501-0108 or roy@leaguecityyachtsales.com. He now lives in League City,
                meeting with him is easy.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="broker-detail-card">
        <div class="broker-profile-container">
          <div>
            <img src="assets/images/team/cmit.png" width="220" height="100" alt="CMIT Solutions"
              class="broker-profile-img" />
          </div>
          <div class="broker-content-wrapper">
            <h3 class="broker-name-large">
              CMIT Solutions
              <span class="broker-title">Technology Partner</span>
            </h3>
            <div class="broker-bio">
              <p>CMIT Solutions provides cutting-edge technology support for our brokerage operations, ensuring seamless
                integration and optimal performance of our systems.</p>
            </div>
          </div>
        </div>
      </div> -->
      <div class="broker-detail-card">
        <div class="broker-profile-container">
          <div>
            <img src="assets/images/team/tlc-software.jpg" width="220" height="100" alt="TLC Software"
              class="broker-profile-img" />
          </div>
          <div class="broker-content-wrapper">
            <h3 class="broker-name-large">
              TLC Software
              <span class="broker-title">Technology Partner</span>
            </h3>
            <div class="broker-bio">
              <p>TLC Software provides innovative software solutions for our brokerage operations, enhancing efficiency
                and user experience.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="marina-info-section">
  <div class="container">
    <div class="marina-info">
      <div class="marina-image">
        <img src="assets/images/locations/jmk5.jpg" alt="Marina Location" loading="lazy" />
      </div>

      <div class="marina-details">
        <h2>Our floating office is located on Pier 27 at Watergate Marina</h2>
        <p class="rating">★ 4.9 <span class="review-count">(97 reviews)</span></p>
        <p class="address">
          <!-- {{ mainAddress()?.addressLine1 }}<br /> -->
          {{ mainAddress()?.addressLine2 }}<br />
          {{ mainAddress()?.city }}, {{ mainAddress()?.state }} {{ mainAddress()?.zipCode }}
        </p>
        <div class="address" style="display: flex; gap: 5px; margin-bottom: 16px;">
          <span style="white-space: nowrap;">Contact :</span>
          <div>
            {{ mainAddress()?.phone }}
            <!-- <br />+1 713-245-6662 -->
          </div>
        </div>
        <p class="email">Email : {{ mainAddress()?.email }}</p>
        <div class="hours" style="margin-bottom: 20px;">
          <p style="margin-bottom: 5px;">Office hours:</p>
          <div style="margin-left: 20px;">
            <table>
              <tr>
                <td>Monday - Friday</td>
                <td>:&nbsp; 9:00 AM - 5:00 PM</td>
              </tr>
              <tr>
                <td>Saturday</td>
                <td>:&nbsp; 10:00 AM - 4:00 PM</td>
              </tr>
              <tr>
                <td>Sunday</td>
                <td>:&nbsp; By Appointment</td>
              </tr>
            </table>
            <!-- Monday - Friday&nbsp; :&nbsp; 9:00 AM - 5:00 PM<br>
            Saturday &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;: 10:00 AM - 4:00 PM<br>
            Sunday &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;: By Appointment -->
          </div>
        </div>
        <div class="marina-actions">
          <a class="btn-luxury primary" href="tel:+1 713-245-6222">Call</a>
          <a class="btn-luxury secondary" href="https://www.google.com/maps/search/?api=1&query={{ mainAddress()?.latitude }},{{
              mainAddress()?.longitude
            }}" target="_blank" rel="noopener noreferrer">Directions</a>
          <!-- <a class="btn-luxury secondary" href="https://www.google.com/maps/search/?api=1&query=LeagueCityYachtSales, 1203 Twin Oaks Blvd - Pier J, Kemah, TX 77565"
            target="_blank" rel="noopener noreferrer">Directions</a> -->
          <!-- <a class="btn-luxury secondary" href="https://leaguecityyachtsales.com" target="_blank"
            >Website</a
          > -->
        </div>
      </div>
    </div>
  </div>
</section>

<!-- <section class="best-selling-section">
    <div class="container">
        <app-section-title title="Best Selling Yachts" theme="dark"></app-section-title>
        <div class="products-grid">
            @for (yacht of bestSellingYachts; track yacht.id) {
            <app-product-card [product]="yacht"></app-product-card>
            }
        </div>
        <div class="view-all">
            <a href="#">See All →</a>
        </div>
    </div>
</section> -->

<section class="faq-section">
  <div class="container">
    <app-section-title title="Frequently Ask Questions" theme="dark"></app-section-title>
    <div class="faq-grid">
      @for (faq of faqs; track faq.faqQuestion) {
      <app-faq-accordion [item]="faq"></app-faq-accordion>
      }
    </div>
  </div>
</section>

<section class="reviews-section">
  <div class="container">
    <app-section-title title="Google Customer Reviews" theme="dark"></app-section-title>
    <div class="reviews-grid">
      @for (review of reviews; track review.id) {
      <app-testimonial-card [testimonial]="review"></app-testimonial-card>
      }
    </div>
  </div>
</section>
